import React from 'react';
import './skeleton.css';

// Bloc skeleton générique — un rectangle qui pulse. Composer les pages de chargement
// avec ce seul primitif pour que toutes les plateformes prof partagent la même animation.
export function Skeleton({ width = '100%', height = 14, radius = 6, style = {} }) {
    return (
        <div
            className="prof-skeleton"
            style={{ width, height, borderRadius: radius, ...style }}
        />
    );
}

export function SkeletonCircle({ size = 34, style = {} }) {
    return <Skeleton width={size} height={size} radius="50%" style={style} />;
}

export default Skeleton;
